import React, { useState } from 'react';
import { MdAdd, MdSettings, MdFilterList, MdArrowDropDown, MdBusiness, MdSearch, MdEdit, MdLogin, MdVisibility } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import ViewDetailsModal from './ViewDetailsModal';
import TableLoadingWrapper from './TableLoadingWrapper';
import '../styles/views.css';

const MMDAsView = ({
  pagedFilteredData,
  pageCount,
  handlePageClick,
  setIsAddMmdaModalOpen,
  setEditMmda,
  setIsEditMmdaModalOpen,
  onMmdaLogin,
  loading,
}) => {
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [viewMmda, setViewMmda] = useState(null);

  return (
    <>
      {/* MMDA Management Header - MMDA Style */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 20,
        padding: '15px 20px',
        backgroundColor: '#f8f9fa',
        borderRadius: 8,
        border: '1px solid #e9ecef'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <MdBusiness size={24} style={{ color: '#1976d2' }} />
          <h3 style={{ margin: 0, color: '#333', fontSize: 18, fontWeight: 'bold' }}>
            MMDA Management
          </h3>
        </div>

        <button
          onClick={() => setIsAddMmdaModalOpen(true)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '10px 16px',
            backgroundColor: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: 6,
            cursor: 'pointer',
            fontSize: 14,
            fontWeight: 'bold',
            boxShadow: '0 2px 4px rgba(40, 167, 69, 0.3)',
          }}
        >
          <MdAdd size={18} />
          Add New MMDA
        </button>
      </div>
      {/* MMDAs Table - MMDA Style */}
      <TableLoadingWrapper loading={loading}>
        <div style={{ overflowX: 'auto' }}>
          <table>
            <thead>
              <tr>
                <th>MMDA Name</th>
                <th>Region</th>
                <th>District Code</th>
                <th>Created Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {(pagedFilteredData || []).map((row, i) => (
                <tr key={i} style={{ cursor: 'default' }}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>

                      <strong>{row.name}</strong>
                    </div>
                  </td>
                  <td>
                    <span style={{
                      padding: '4px 8px',
                      backgroundColor: '#e3f2fd',
                      borderRadius: 4,
                      fontSize: 12,
                      fontWeight: 'bold',
                      color: '#1976d2'
                    }}>
                      {row.region}
                    </span>
                  </td>
                  <td>
                    <span style={{
                      padding: '4px 8px',
                      backgroundColor: '#f5f5f5',
                      borderRadius: 4,
                      fontSize: 12,
                      color: '#666',
                      fontFamily: 'monospace'
                    }}>
                      {row.district_code}
                    </span>
                  </td>
                  <td>
                    {row.created_at ? new Date(row.created_at).toLocaleDateString() : 'N/A'}
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: 8 }}>


                      <button
                        onClick={() => {
                          setEditMmda(pagedFilteredData[i]);
                          setIsEditMmdaModalOpen(true);
                        }}
                        style={{
                          padding: '6px 12px',
                          backgroundColor: '#ff9800',
                          color: 'white',
                          border: 'none',
                          borderRadius: 4,
                          cursor: 'pointer',
                          fontSize: 12,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 4
                        }}
                      >
                        <MdEdit size={14} />
                        Edit
                      </button>

                      <button
                        onClick={() => {
                          // Handle MMDA login
                          console.log('Login to MMDA:', row);
                          if (onMmdaLogin) {
                            onMmdaLogin(row);
                          }
                        }}
                        style={{
                          padding: '6px 12px',
                          backgroundColor: '#4caf50',
                          color: 'white',
                          border: 'none',
                          borderRadius: 4,
                          cursor: 'pointer',
                          fontSize: 12,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 4
                        }}
                      >
                        <MdLogin size={14} />
                        Login
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </TableLoadingWrapper>

      {/* MMDA Style Pagination */}
      {pageCount > 1 && (
        <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center' }}>
          <ReactPaginate
            previousLabel={'previous'}
            nextLabel={'next'}
            breakLabel={'...'}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            activeClassName={'active'}
          />
        </div>
      )}

      {/* MMDA Management Info */}

      {/* View Details Modal */}
      <ViewDetailsModal
        isOpen={isViewModalOpen}
        onClose={() => setIsViewModalOpen(false)}
        data={viewMmda}
        type="mmda"
        title="MMDA Details"
      />
    </>
  );
};

export default MMDAsView;
